export default "/images/52f6967881d9cebee13ddfdac30ba0bb.jpg";